module.exports = __webpack_public_path__ + "img/carrotdown.c60755b8.svg";